import { Component, HostBinding, Input } from "@angular/core";
import './skeleton-loader.component.scss';

type AppearanceType = "line" | "box" | "circle";
type OrientatationType = "horizontal" | "vertical";

@Component({
    selector: 'skeleton-loader',
    template: require('./skeleton-loader.component.html')
})
export class SkeletonLoaderComponent {
    @Input() count = 1;
    @Input() appearance: AppearanceType = "line";
    @Input() @HostBinding("class") orientation: OrientatationType = "vertical";

    numbers: Array<any>;

    constructor() { }

    ngOnInit(): void {
        this.createNumberArray();
    }

    ngOnChanges(): void {
        this.createNumberArray();
    }

    // ---

    private createNumberArray(): void {
        if (typeof this.count !== "number") {
            this.count = Number(this.count);
        }

        this.numbers = Array(this.count).fill(this.count);
    }
}
